import { Pipe, PipeTransform } from '@angular/core';
import {plainToInstance} from "class-transformer";
import {FileLinkModel} from "../models/file-link.model";

@Pipe({
  name: 'toFileLinkModel'
})
export class ToFileLinkModelPipe implements PipeTransform {

  transform(value: string | object, ...args: unknown[]): FileLinkModel {
    let json;
    if (typeof value == "string") {
      json = this.tryParseJSON(value);
    } else {
      json = value;
    }

    if (json) {
      if(Array.isArray(json)){
        let fileLinkModels = plainToInstance(FileLinkModel, json);
        return fileLinkModels.reverse()[0];
      }else {
        return plainToInstance(FileLinkModel, json);
      }

    } else {
      return new FileLinkModel();
    }
  }

  tryParseJSON(jsonString) {
    try {
      const o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        return  o;
      }
    } catch (e) {
      console.error(e);
    }
  };
}
